import LineButton, { LineButtonProps } from './LineButton';

export type { LineButtonProps };
export default LineButton;
